// Баннер «Включить push-уведомления» на странице /support/my.
// Показываем только если:
//   - браузер поддерживает Push API
//   - permission ещё не запрошен или granted, но подписка не активна
// При permission='denied' — показываем подсказку как разблокировать
// (юзер сам должен пойти в настройки сайта).
import React, { useEffect, useState } from "react";
import { BellIcon } from "../icons/BellIcon";
import {
  supported, permission, enable, disable, currentSubscription,
} from "../../api/webPush";

const KEY_DISMISSED = "rublox_push_banner_dismissed";

export default function WebPushBanner() {
  const [state, setState] = useState("loading"); // loading|offer|on|denied|dismissed|unsupported
  const [err, setErr] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!supported()) {
        if (!cancelled) setState("unsupported");
        return;
      }
      const perm = permission();
      if (perm === "denied") {
        if (!cancelled) setState("denied");
        return;
      }
      const sub = await currentSubscription();
      if (sub) {
        if (!cancelled) setState("on");
        return;
      }
      const dismissed = localStorage.getItem(KEY_DISMISSED) === "1";
      if (!cancelled) setState(dismissed ? "dismissed" : "offer");
    })();
    return () => { cancelled = true; };
  }, []);

  if (state === "loading" || state === "unsupported" || state === "dismissed") {
    return null;
  }

  const turnOn = async () => {
    setErr(null);
    const r = await enable();
    if (r.ok) setState("on");
    else {
      setState(r.reason === "denied" ? "denied" : "offer");
      setErr(r.error || r.reason || "Не удалось включить");
    }
  };

  const turnOff = async () => {
    setErr(null);
    await disable();
    setState("offer");
  };

  const dismiss = () => {
    localStorage.setItem(KEY_DISMISSED, "1");
    setState("dismissed");
  };

  if (state === "denied") {
    return (
      <div className="sup-msg-info" style={{ display: "flex", gap: 10,
                                              alignItems: "center",
                                              marginBottom: 14 }}>
        <BellIcon size={20} color="#94a3b8" />
        <span style={{ flex: 1 }}>
          Push-уведомления заблокированы. Чтобы получать ответы МИНа без
          захода на сайт — открой настройки сайта в браузере и разреши
          уведомления.
        </span>
        <button type="button" className="sup-btn-ghost" onClick={dismiss}>
          Скрыть
        </button>
      </div>
    );
  }

  if (state === "on") {
    return (
      <div className="sup-msg-ok" style={{ display: "flex", gap: 10,
                                            alignItems: "center",
                                            marginBottom: 14 }}>
        <BellIcon size={20} color="#065f46" />
        <span style={{ flex: 1 }}>
          Push-уведомления включены. Браузер покажет ответ МИНа,
          даже если эта вкладка закрыта.
        </span>
        <button type="button" className="sup-btn-ghost" onClick={turnOff}>
          Отключить
        </button>
      </div>
    );
  }

  // offer
  return (
    <div className="sup-msg-info" style={{ display: "flex", gap: 10,
                                            alignItems: "center",
                                            marginBottom: 14 }}>
      <BellIcon size={20} color="#3357ff" />
      <span style={{ flex: 1 }}>
        Получать ответы МИНа push-уведомлением? Браузер покажет
        ответ сразу, даже если вкладка закрыта.
      </span>
      {err && <span style={{ color: "#991b1b", fontSize: 12 }}>{err}</span>}
      <button type="button" className="sup-btn-primary" onClick={turnOn}>
        Включить
      </button>
      <button type="button" className="sup-btn-ghost" onClick={dismiss}>
        Не сейчас
      </button>
    </div>
  );
}
